import React, { Component } from "react";
import logo from "../assets/wheeling_station_marker.png";
import "./Station.css";
import disponible from "../assets/disponible.png";
import cargando from "../assets/cargando.png";
import ocupados from "../assets/ocupados.png";

export default class Station extends Component {
    state = {
        infoWindow: false
    }
    render() {
        let infoWindow = null;
        if (this.state.infoWindow) {
            infoWindow = (
                <div style={{ position: "absolute", zIndex: 1000, width: 200, height: 150, padding: 10, backgroundColor: "#FFF", bottom: 10, left: -90, borderRadius: 10, boxShadow: "1px 1px 5px #cbcbcb", display: "flex", flexDirection: "column", justifyContent: "center" }}>
                    <div style={{ position: "absolute", right: 10, top: 5 }} onClick={() => this.setState({ infoWindow: false })}>x</div>
                    <b style={{ marginBottom: 10 }}>{this.props.data.name}</b>
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignContent: 'space-between' }}>
                        {Object.keys(this.props.data.slots).map((d, k) => {
                            let { available, charge, charging } = this.props.data.slots[d];
                            let label = null;
                            let cl = "";
                            let icon = "";

                            if (available) {
                                label = "DISPONIBLE";
                                cl = "available";
                                icon = disponible;
                            } else {
                                if (charging) {
                                    if (charge > 0) {
                                        label = charge + "% ";
                                        cl = "charging";
                                        icon = cargando;
                                    } else {
                                        label = "CONECTANDO";
                                        cl = "connecting";
                                        icon = ocupados;
                                    }
                                } else {
                                    label = "CONECTANDO";
                                    cl = "connecting";
                                    icon = ocupados;
                                }
                            }

                            return (
                                <div key={k} style={{ display: "flex", flexDirection: "row", width: '50%', padding: 10, justifyContent: "center" }}>
                                    <img alt="" src={icon} style={{ height: 25, width: 25 }} />
                                    <p style={{ margin: 5 }}>Slot {k + 1} </p>
                                    {/* <p className={cl}> {label}</p> */}
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        }

        const totalSlots = Object.keys(this.props.data.slots).length;
        const available = Object.values(this.props.data.slots).filter((obj, key) => obj.available === true).length;
        const unavailable = Object.values(this.props.data.slots).filter((obj, key) => obj.available === false).length;
        const charging = Object.values(this.props.data.slots).filter((obj, key) => obj.charging === true).length;
        // const uncharging = Object.values(this.props.data.slots).filter((obj, key) => obj.charging === false).length;

        return (
            <div style={{ cursor: 'pointer' }} onClick={() => this.setState({ infoWindow: !this.state.infoWindow })}>
                {infoWindow}
                <div style={{ width: '15px', height: '15px', backgroundColor: '#3b7cff', borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", color: "#FFF", position: "absolute", right: -8, top: -15, zIndex: 500 }}>
                    {totalSlots}
                </div>
                <div style={{ width: '15px', height: '15px', backgroundColor: '#f93732', borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", color: "#FFF", position: "absolute", right: -23, top: -15, zIndex: 500 }}>
                    {unavailable}
                </div>
                <div style={{ width: '15px', height: '15px', backgroundColor: '#ffce00', borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", color: "#FFF", position: "absolute", right: -38, top: -15, zIndex: 500 }}>
                    {charging}
                </div>
                <div style={{ width: '15px', height: '15px', backgroundColor: '#4cdc74', borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", color: "#FFF", position: "absolute", right: -52, top: -15, zIndex: 500 }}>
                    {available}
                </div>
                <img alt="" src={logo} style={{ width: '40px', height: '50px' }} />
            </div>
        )
    }
}